export default __webpack_public_path__ + "static/media/luggage 1.475d7a18.svg";